import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
class BaromoneyApi extends Requestor {
    getBaromoney(params = {}) {
        return this.get({
            url: '/api/v1/baromoney/me',
            params,
        });
    }
    getBaromoneyHistory(params = {}) {
        return this.get({
            url: '/api/v1/baromoney/history/me',
            params,
        });
    }
    postBaromoneyRemittance(data = {}) {
        return this.post({
            url: '/api/v1/baromoney/remittance',
            data,
        });
    }
    /**
     * 라이더 바로머니 내역 조회
     */
    getWorkerBaromoneyHistory(params = {}) {
        return this.get({
            url: '/api/v1/baromoney/history/workers',
            params,
        });
    }
    /**
     * 단일 라이더 바로머니 내역 조회
     */
    getWorkerBaromoneyHistoryByWorkerCode(workerCode, params = {}) {
        return this.get({
            url: `/api/v1/baromoney/history/workers/${workerCode}`,
            params,
        });
    }
}
export default new BaromoneyApi(clientInstance);
